import * as React from "react";

import { cn } from "@/lib/helper/utils";

const CustomCard = ({ className, ...props }: React.ComponentProps<"div">) => {
  return (
    <div
      className={cn(
        " rounded-[6px] ",
        className
      )}
      {...props}
    />
  );
};

export default CustomCard;
